import actionTypes, { changePasswordActionTypes } from "accounts/account-action-types"
import { sendAction } from "shared/djangio/action-creators"
import swal from "sweetalert"
import accountsConstants, { forgotPassValue } from "accounts/accountsConstants"
import { passwordStrengthThreshold } from "registration/constants"

export const validateIfHasPassword = (immutableValues, props, possessiveString = "the") => {
    const errors = {}

    const password = immutableValues.get("password")
    const passwordConfirm = immutableValues.get("passwordConfirm")
    const score = props.passwordScore

    if (password && score < passwordStrengthThreshold) {
        errors.password = `Please make sure that ${possessiveString} password matches the security requirements.`
    } else if (password && !passwordConfirm) {
        errors.passwordConfirm = `To set a new password, confirm ${possessiveString} new password.`
    } else if (password !== passwordConfirm) {
        errors.passwordConfirm = `Please make sure that ${possessiveString} passwords match.`
    }

    return errors
}

export const validateAccountSecurityForm = (immutableValues, props) => {
    const values = immutableValues.toJS()
    let errors = {}

    if (!values.password) {
        errors.password = "To set a new password, type a new password."
    } else {
        errors = {
            ...errors,
            ...validateIfHasPassword(immutableValues, props, "your"),
        }
    }

    return errors
}

const forgotPassword = "User clicked Forgot Password."
const cancelError = "You canceled the operation."
const wrongPasswordErrorFromBackend = "Error: Request failed with status code 401"

/**
 * Returns a function that calls the API backend to change a user's password.
 * @param  {Object} user an object with password and currentPassword fields
 * @return {Function}     result of sendAction
 */
export const updatePassword = (user) => {
    return sendAction(DjangIO.app.userdata.models.QuorumUser, changePasswordActionTypes, {
        action: "change_password",
        kwargs: user,
        method: "patch",
    })
}

export const onSubmit = async (immutableFormValues, dispatch, props) => {
    let currentPassword = undefined
    if (!Userdata.logged_in_as_user) {
        // Only do check if user is editing their own info
        currentPassword = await swal(accountsConstants.confirmChange)
        if (currentPassword === forgotPassValue) {
            window.location = "/recover/"
            throw forgotPassword
        } else if (currentPassword === null) {
            throw cancelError
        }
    }
    const newPassword = immutableFormValues.get("password")

    return dispatch(updatePassword({ user_id: Userdata.id, newPassword, currentPassword }))
}

export const onSubmitSuccess = (result, dispatch, props) => {
    swal({
        icon: "success",
        title: "Success!",
        text: "The password was successfully changed.",
    })
    window.location = "" // If password is successfully reset, the user gets logged out.
    // Therefore, we reload the app to save them the surprise from thinking they are logged in.
}

export const onSubmitFail = (result, dispatch, error, props) => {
    let errorText =
        "There was an error with saving your password. Please make sure that your passwords match and meet the security requirements."

    if (error === cancelError || error === forgotPassword) {
        return
    } else if (error && error.toString() === wrongPasswordErrorFromBackend) {
        errorText = "This password is incorrect. Please check it again."
    }

    swal({
        icon: "error",
        title: error.response?.status === 422 ? "Your password needs adjustment" : "Something went wrong.",
        text: error.response?.status === 422 ? error.response.data : errorText,
    })
}

export const changePropValue = (key, value) => ({ type: actionTypes.CHANGE_INFO, key, value })
